<template>
  <b-card>
    <layout-loading v-if="isSubmit" />
    <b-form class="box-messages box-messages1">
      <b-row>
        <b-col md="4">
          <b-form-group
            :label="$t('users.fromUSC')"
            label-for="user-fromUSC"
            class="mb-2"
          >
            <date-picker
              id="user-fromUSC"
              v-model="form.from"
              :column="1"
              mode="single"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group
            :label="$t('users.toUSC')"
            label-for="user-toUSC"
            class="mb-2"
          >
            <date-picker
              id="user-toUSC"
              v-model="form.to"
              :column="1"
              mode="single"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-button
            v-if="!loading"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1 mt-2"
            :disabled="isSubmit"
            @click="submitForm"
          >
            {{ $t("users.uscBtn") }}
          </b-button>
          <b-button
            v-if="loading"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1 mt-2"
            :disabled="isSubmit"
            @click="submitForm"
          >
            {{ $t("users.uscBtnLoading") }}
          </b-button>
        </b-col>
      </b-row>
      <b-row v-if="result">
        <b-col
          v-if="result.count"
          md="12"
          class="mt-2"
        >
          <p>
            <strong>{{ $t('users.countUserSignUp') }} :</strong> {{ result.count }} {{ $t('users.userCount') }}
          </p>
          <div id="dl-box" />
        </b-col>
        <b-col
          v-if="result.users && result.users.length != 0"
          md="12"
          class="mb-2"
        >
          <div>
            <BDataTable
              ref="refTable"
              :searchable="false"
              :fetch-list="fetchList"
              :table-columns="tableColumns"
            >
              <template #cell(isVerifiedPhoneNumber)="data">
                <span
                  :class="data.item.isVerifiedPhoneNumber ? 'text-green' : 'text-red'"
                  class="align-text-top"
                >
                  {{ data.item.isVerifiedPhoneNumber ? $t('users.isVerifiedPhoneNumber') : $t('users.isNotVerifiedPhoneNumber') }}
                </span>
              </template>
              <template #cell(createdAt)="data">
                <div class="text-nowrap">
                  <span class="align-text-top text-capitalize">{{ data.item.createdAt | moment("jYYYY/jMM/jD") }}</span>
                </div>
              </template>
            </BDataTable>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BCard, BCol, BRow, BForm, BFormGroup, BButton,
} from 'bootstrap-vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import { required } from 'vuelidate/lib/validators'
import Ripple from 'vue-ripple-directive'
import BDataTable from '@/components/BDataTable/index.vue'
import useSignupCheck from './useSignupCheck'

export default {
  name: 'UseSignupCheck',
  components: {
    BCol,
    BForm,
    BCard,
    BRow,
    BButton,
    BFormGroup,
    LayoutLoading,
    BDataTable,
  },
  directives: {
    Ripple,
  },
  setup() {
    const {
      fetchUserSignUp,
      isSubmit,
      result1,
      result,
      fetchList,
      loading,
      tableColumns,
    } = useSignupCheck()
    return {
      fetchUserSignUp,
      isSubmit,
      result1,
      result,
      loading,
      fetchList,
      tableColumns,
    }
  },
  data() {
    return {
      form: {
        from: '',
        to: '',
      },
    }
  },
  validations() {
    return {
      form: {
        from: { required },
        to: { required },
      },
    }
  },
  methods: {
    submitForm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        return
      }
      const data = {
        from: this.form.from,
        to: this.form.to,
      }
      this.fetchUserSignUp(data)
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
  },
}
</script>
<style>
.box-messages1 .pdp .pdp-group .pdp-input{
    height: calc(1.5em + 0.75rem + 4px);
}
.text-green {
    color: rgb(62, 158, 62);
}
.text-red {
    color: rgb(158, 62, 62);
}
#dl-box {
    height: 40px;
}
.newALink{
    padding: 5px 15px;
    border: 1px solid #3c8b89;
    border-radius: 6px;
    margin: 10px 0;
    color: #ffffff;
    background: #3c8b89;
}
.newALink:hover {
    color: #fff;
    background: #275e5c;
}
</style>
